import { useEffect } from "react";
import { VisitorsNumbersBySourceGraph } from "../../../../components/Graphs/graphs";

import { useSelector, useDispatch } from "react-redux";
import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";
import { LoadingAnimation } from "../../../../components/Loading/LoadingAnimation";
import {
  graphUTMSource,
  SelectUTMSourceStatus,
  SelectVisitors,
  SelectPercentBooking,
  SelectPercentBought,
  SelectWeeks,
  SelectLabels,
} from "./utmSourceSlice";
import { SingleGraphLoading } from "../../../../components/Skeletons";

const UTMSource = ({ display }) => {
  const dispatch = useDispatch();
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];

  const UTMSourceData = useSelector((state) => state.utmSource);
  console.log("UTMSourceData", UTMSourceData)
  const loading = useSelector(SelectUTMSourceStatus);
  const weeks = useSelector(SelectWeeks);
  const visitors = useSelector(SelectVisitors);
  const percentBooking = useSelector(SelectPercentBooking);
  const percentBought = useSelector(SelectPercentBought);
  const adsLabels = useSelector(SelectLabels);

  useEffect(() => {
    if (!user) return null;
    if(weeks.length===0) dispatch(graphUTMSource(user));
  }, [user, weeks]);

  if (loading === "loading") return <SingleGraphLoading />;

  return (
    <VisitorsNumbersBySourceGraph
      loading={loading === "loading"}
      display={display}
      weeks={weeks}
      visitors={visitors}
      percentOfBooking={percentBooking}
      nameLabels={adsLabels}
      totalSales={percentBought}
    />
  );
};

export default UTMSource;